import { DatePrecision } from '../DatePrecision';
import type { DateRepresentation } from '../DateRepresentation';
import { safeParseDate } from '../parse/date';
import { formatEST } from './formatEST';

export function formatISO(date: DateRepresentation, formatType?: DatePrecision): string | undefined {
	const dateValue = safeParseDate(date);
	if (!dateValue) {
		return undefined;
	}

	if (formatType === DatePrecision.Day) {
		return formatEST(dateValue, 'yyyy-MM-dd');
	}

	try {
		// Return the normalized ISO string.
		return dateValue.toISOString();
	} catch {
		// Fallback if toISOString() fails (e.g., invalid date)
		return undefined;
	}
}
